export interface CountryCode {
  code: string;
  name: string;
  dial: string;
  flag: string;
}

export const COUNTRY_CODES: CountryCode[] = [
  { code: 'DE', name: 'Germany', dial: '49', flag: '\u{1F1E9}\u{1F1EA}' },
  { code: 'AE', name: 'UAE', dial: '971', flag: '\u{1F1E6}\u{1F1EA}' },
  { code: 'US', name: 'United States', dial: '1', flag: '\u{1F1FA}\u{1F1F8}' },
  { code: 'GB', name: 'United Kingdom', dial: '44', flag: '\u{1F1EC}\u{1F1E7}' },
  { code: 'FR', name: 'France', dial: '33', flag: '\u{1F1EB}\u{1F1F7}' },
  { code: 'NL', name: 'Netherlands', dial: '31', flag: '\u{1F1F3}\u{1F1F1}' },
  { code: 'TR', name: 'Turkey', dial: '90', flag: '\u{1F1F9}\u{1F1F7}' },
  { code: 'SG', name: 'Singapore', dial: '65', flag: '\u{1F1F8}\u{1F1EC}' },
  { code: 'HK', name: 'Hong Kong', dial: '852', flag: '\u{1F1ED}\u{1F1F0}' },
  { code: 'QA', name: 'Qatar', dial: '974', flag: '\u{1F1F6}\u{1F1E6}' },
  { code: 'AT', name: 'Austria', dial: '43', flag: '\u{1F1E6}\u{1F1F9}' },
  { code: 'CH', name: 'Switzerland', dial: '41', flag: '\u{1F1E8}\u{1F1ED}' },
  { code: 'ES', name: 'Spain', dial: '34', flag: '\u{1F1EA}\u{1F1F8}' },
  { code: 'IT', name: 'Italy', dial: '39', flag: '\u{1F1EE}\u{1F1F9}' },
  { code: 'AU', name: 'Australia', dial: '61', flag: '\u{1F1E6}\u{1F1FA}' },
  { code: 'JP', name: 'Japan', dial: '81', flag: '\u{1F1EF}\u{1F1F5}' },
  { code: 'KR', name: 'South Korea', dial: '82', flag: '\u{1F1F0}\u{1F1F7}' },
  { code: 'IN', name: 'India', dial: '91', flag: '\u{1F1EE}\u{1F1F3}' },
  { code: 'TH', name: 'Thailand', dial: '66', flag: '\u{1F1F9}\u{1F1ED}' },
  { code: 'BR', name: 'Brazil', dial: '55', flag: '\u{1F1E7}\u{1F1F7}' },
  { code: 'ZA', name: 'South Africa', dial: '27', flag: '\u{1F1FF}\u{1F1E6}' },
  { code: 'IE', name: 'Ireland', dial: '353', flag: '\u{1F1EE}\u{1F1EA}' },
  { code: 'SE', name: 'Sweden', dial: '46', flag: '\u{1F1F8}\u{1F1EA}' },
  { code: 'NO', name: 'Norway', dial: '47', flag: '\u{1F1F3}\u{1F1F4}' },
  { code: 'DK', name: 'Denmark', dial: '45', flag: '\u{1F1E9}\u{1F1F0}' },
  { code: 'PL', name: 'Poland', dial: '48', flag: '\u{1F1F5}\u{1F1F1}' },
  { code: 'PT', name: 'Portugal', dial: '351', flag: '\u{1F1F5}\u{1F1F9}' },
  { code: 'GR', name: 'Greece', dial: '30', flag: '\u{1F1EC}\u{1F1F7}' },
  { code: 'CN', name: 'China', dial: '86', flag: '\u{1F1E8}\u{1F1F3}' },
  { code: 'PH', name: 'Philippines', dial: '63', flag: '\u{1F1F5}\u{1F1ED}' },
];
